import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

class CustomTeaserboxVC extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      trigger: false,
    }
    this.firstFunction = this.firstFunction.bind(this)
  }

  firstFunction() {}

  render() {
    const { data, strings } = this.props

    console.log(data) //eslint-disable-line

    return (
      <div className="dhsv_vc_custom_teaserbox">
        <a href={data.permalink.url}>
          <div className="inner">
            <div
              className="image"
              style={{
                backgroundImage: data.featimage
                  ? 'url(' + data.featimage + ')'
                  : null,
              }}
            />
            <div className="meta">
              <h3 dangerouslySetInnerHTML={{ __html: data.title }} />
              <div className="excerpt">{data.teaser}</div>
              <div className="more">
                <a href={data.permalink.url}>
                  {data.permalink.title
                    ? data.permalink.title
                    : strings.readmore}
                </a>
              </div>
            </div>
          </div>
        </a>
      </div>
    )
  }
}

CustomTeaserboxVC.propTypes = {
  data: PropTypes.opbject,
  strings: PropTypes.object,
}

export default CustomTeaserboxVC
